import { ref, computed } from "vue";

const STORAGE_KEY = "real-estate-theme";

export const theme = ref("light");

function getSystemTheme() {
  return window.matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";
}

function updateThemeColor(value) {
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.content = value === "dark" ? "#232333" : "#f5f5f9";
  }
}

export function applyTheme(value) {
  theme.value = value;
  document.documentElement.setAttribute("data-theme", value);
  document.documentElement.style.colorScheme = value;
  updateThemeColor(value);
}

export function initTheme() {
  let stored = null;

  try {
    stored = localStorage.getItem(STORAGE_KEY);
  } catch {
    /* private browsing */
  }

  const resolved =
    stored === "dark" || stored === "light" ? stored : getSystemTheme();
  applyTheme(resolved);
  return resolved;
}

export function useTheme() {
  const isDark = computed(() => theme.value === "dark");

  function toggleTheme() {
    const next = theme.value === "dark" ? "light" : "dark";

    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* private browsing */
    }

    applyTheme(next);
  }

  return { theme, isDark, toggleTheme };
}
